import { Component } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AwallComponentEvent } from '../models/awallComponentEvent';
import { BoardData } from '../models/boardData';
import { ComponentEvent } from '../models/enums/componentEvent';

/**
 * Base-Class for Action-View Boards. Provides functionality shared by all boards.
 */
@Component({
  template: ''
  })
export abstract class BaseBoardComponent {

  public subscriptions: Subscription[] = [];
  public backgroundVideoIsActive = false;

  constructor() { }

  abstract getBoardData(): Observable<BoardData>;

  public onCommunicationEvent(event: AwallComponentEvent): void {
    if (!event) { return; }

    switch (event.name) {
      // VTR-Widget sends us an event when a video goes to fullscreen so we can make the background transparent
      case ComponentEvent.WIDGET_VTR_VIDEO_ACTIVE: {
        this.backgroundVideoIsActive = <boolean>event.value;
        break;
      }
    }
  }



}
